const existeNumero = /\d/;
const existeLetraMinuscula = /[a-z]/;
const existeLetraMaiuscula = /[A-Z]/;
const existeCaractereEspecial = new RegExp("[@!#$%^&*()/\\\\]");
const tamanhoMinimoSenha = 7;

export function senhaAtendeRequisitos(senha: string) {
    return senha.length >= tamanhoMinimoSenha
        && existeCaractereEspecial.test(senha)
        && existeLetraMaiuscula.test(senha)
        && existeLetraMinuscula.test(senha)
        && existeNumero.test(senha);
}

export function TestarSegurancaSenha(
    senha: string,
    setValidacao: (value: React.SetStateAction<boolean>) => void,
    setTamanhoSenha: (value: React.SetStateAction<boolean>) => void,
    setCaracterEspecial: (value: React.SetStateAction<boolean>) => void,
    setLetraMaiuscula: (value: React.SetStateAction<boolean>) => void,
    setLetraMinuscula: (value: React.SetStateAction<boolean>) => void,
    setNumeros: (value: React.SetStateAction<boolean>) => void,
) {
    if (senhaAtendeRequisitos(senha))
        setValidacao(false);
    else {
        setTamanhoSenha(senha.length >= tamanhoMinimoSenha);
        setCaracterEspecial(existeCaractereEspecial.test(senha));
        setLetraMaiuscula(existeLetraMaiuscula.test(senha));
        setLetraMinuscula(existeLetraMinuscula.test(senha));
        setNumeros(existeNumero.test(senha));

        setValidacao(true);
    }
}
